module.exports = __webpack_public_path__ + "assets/images/02_active_afcfdddf7aa200aabac7785e53ad22bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/02_active.png
// module id = 118
// module chunks = 0